import React from 'react';
import Icons from './Icons';
import { Card } from './ui';

const FantasySeasonCard = ({ participant, rank, isTop3 }) => {
    return (
        <Card
            className={`mb-4 border-l-4 ${rank === 1 ? 'border-gold-400' :
                    rank === 2 ? 'border-gray-400' :
                        rank === 3 ? 'border-orange-400' :
                            'border-transparent'
                }`}
            gradient={rank <= 3}
        >
            <div className="flex items-center justify-between mb-3">
                <div className="flex items-center space-x-3">
                    <div className={`
            flex items-center justify-center w-8 h-8 rounded-full font-bold text-sm
            ${rank === 1 ? 'bg-gold-400 text-forest-950' :
                            rank === 2 ? 'bg-gray-300 text-gray-800' :
                                rank === 3 ? 'bg-orange-300 text-orange-900' :
                                    'bg-gray-100 text-gray-600'}
          `}>
                        {rank}
                    </div>
                    <div>
                        <h3 className="font-bold text-forest-900 dark:text-gray-100">{participant.participant_name || participant.participant_id}</h3>
                        <div className="text-xs text-gray-500 dark:text-gray-400">{participant.events_played} Events</div>
                    </div>
                </div>
                <div className="text-right">
                    <div className="text-xl font-bold text-blue-600 dark:text-blue-400">{participant.total_points || 0}</div>
                    <div className="text-xs text-gray-400 uppercase">Points</div>
                </div>
            </div>

            <div className="grid grid-cols-3 gap-2 pt-3 border-t border-gray-100 dark:border-gray-700">
                <div className="text-center">
                    <div className="text-xs text-gray-500 dark:text-gray-400 mb-1">Avg/Event</div>
                    <div className="font-semibold text-gray-700 dark:text-gray-200">
                        {participant.avg_points_per_event && !isNaN(participant.avg_points_per_event)
                            ? Number(participant.avg_points_per_event).toFixed(1)
                            : '0.0'}
                    </div>
                </div>
                <div className="text-center">
                    <div className="text-xs text-gray-500 dark:text-gray-400 mb-1">Best Week</div>
                    <div className="font-semibold text-green-600 dark:text-green-400">{participant.best_week || 0}</div>
                </div>
                <div className="text-center">
                    <div className="text-xs text-gray-500 dark:text-gray-400 mb-1">Winnings</div>
                    <div className={`font-bold ${participant.winnings > 0 ? 'text-green-600 dark:text-green-400' : 'text-gray-400'}`}>
                        ${participant.winnings || 0}
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default FantasySeasonCard;
